import { Injectable } from '@angular/core';

/**
 * Service to manage language
 */
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  language = 'en';
  availableLanguages = ['en', 'es'];

  /**
   * @ignore
   */
  constructor() {}

  /**
   * Function to save language at the localStorage and make a real at the end to apply changes
   * @param language Variable that bring the language
   */
  saveLanguage(language: string) {
    if (language.length === 2) {
      this.language = language;
      localStorage.setItem('language', JSON.stringify(this.language));
      return true;
    } else {
      return false;
    }
  }

  /**
   * Function that returns the current language
   */
  getLanguage() {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      this.language = JSON.parse(storedLanguage);
      return this.language;
    } else {
      var navigatorLanguage = navigator.language;
      navigatorLanguage = this.replaceStr(navigatorLanguage, '[0-9 -]', '');
      navigatorLanguage = navigatorLanguage.slice(0, 2);
      if (this.availableLanguages.includes(navigatorLanguage))
        this.language = navigatorLanguage;
      else this.language = 'en';
      this.saveLanguage(this.language);
      return this.language;
    }
  }

  /**
   * Function that uses the new language
   * @param language Variable that brings the language to be used
   */
  applyLanguage(language: string) {
    this.saveLanguage(language);
  }

  /**
   * Function that returns a true or false if the page has a language
   */
  existLanguage() {
    if (localStorage.getItem('language')) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Function that allows to clean the language string and leave it just on the code of two variables
   * @param value Variable that brings the browser language
   * @param regexValue Characters you want to clean from value
   * @param replaceValue Value you want to give to the characters you may change
   */
  replaceStr(value: string, regexValue: string, replaceValue: string): any {
    const regex = new RegExp(regexValue, 'g');
    return value.replace(regex, replaceValue);
  }
}
